export const ACCESS_TOKEN = 'accessToken';
export const isDemo = 'isDemo';

export const INDICATOR_LIST_SIZE = 30;
export const INDICATOR_NAME_MAX_LENGTH = 40;

export const UNIT_NAME_MAX_LENGTH = 4;

export const NAME_MIN_LENGTH = 1;
export const NAME_MAX_LENGTH = 50;

export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 50;

export const EMAIL_MAX_LENGTH = 50;

export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 20;
